import { render, staticRenderFns } from "./AddCommercialAdmin.vue?vue&type=template&id=9f82bad4"
import script from "./AddCommercialAdmin.vue?vue&type=script&lang=js"
export * from "./AddCommercialAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddCommercialAdmin.vue?vue&type=style&index=0&id=9f82bad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports